import { Image } from '@mantine/core';
import laylaFoodLogo from '../assets/logo.png';

interface LogoProps {
    small?: boolean;
}

const Logo = ({ small }: LogoProps) => {
    return (
        <Image
            maw={small ? 350 : 500}
            alt="LAYLA_FOOD_LOGO"
            src={laylaFoodLogo}
            mx="auto"
        />
    );
};

export default Logo;
